import React from 'react'

export const BorderWrapper = ({ children }) => {
    return <div className="my-4 py-4 xl:my-9 xl:py-6 border-y border-light dark:border-dark">{children}</div>
}
